import request, { type CustomizeConfigType } from '@/utils/request';
import { stringifySearchParams } from '@/utils/url';
import axios from 'axios';
import { first, last } from 'lodash-es';

const ajaxCache = {};

function apiFactory(serviceName: string, methods: string[]) {
  type ServiceType = {
    [key: string]: (data?: any, config?: CustomizeConfigType) => Promise<any> & { abort: Function };
  };
  const serviceObject: ServiceType = methods.reduce((service, apiMethod) => {
    let method = last(apiMethod.split(':')) as string;
    let methodType = apiMethod.split(':').length==2? first(apiMethod.split(':')) as string:'post';
    if (!method) {
      throw new Error(`Invalid apiMethod: ${apiMethod}`);
    }
    service[method] = (data: any, config?: CustomizeConfigType) => {
      const customizeConfig: CustomizeConfigType = Object.assign({
        throwError: true,
      }, config ?? {});
      const api = data?.api;
      let action = `/${serviceName}/${method}`;
      if (process.env.NODE_ENV == 'development' && api) {
        action += '?api=' + encodeURIComponent(api);
      }
      let requestParams = {
        method: methodType,
        url: action,
        responseType: 'json',
        ...(
          methodType == 'get'
            ? {
              params: data,
            }
            : {
              data: data instanceof FormData
                ? data
                : stringifySearchParams(data)
            }
        ),
        __customizeConfig: customizeConfig,
      } as any;

      if (customizeConfig.getAbort) {
        const source = axios.CancelToken.source();
        requestParams.cancelToken = source.token;
        customizeConfig.getAbort(source.cancel);
      }

      // 缓存支持
      if (config?.cache) {
        const catheKey = [
          config.cache == 'route'
            ? window.location.href
            : null,
          serviceName, method, JSON.stringify(data)
        ].filter(Boolean).join('_');
        const cache = ajaxCache[catheKey];
        if (cache) {
          return cache;
        } else {
          return ajaxCache[catheKey] = request(requestParams)
            .catch(() => delete ajaxCache[catheKey]);
        }
      }
      return request(requestParams);
    };
    return service;
  }, {} as ServiceType);
  return serviceObject;
}

export default apiFactory;
